// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1SsVy","subheader":"ReorderModal_subheader__26BYi","listWrap":"ReorderModal_listWrap__3RDaA"};